/**
 * PublicRoute — guard that keeps auth-only pages hidden for signed-in users.
 *
 * Behavior:
 *   - While auth bootstrap is loading -> render nothing to avoid a flash
 *   - If a user is already authenticated -> redirect to /
 *   - Otherwise -> render the public page (login/forgot)
 */
import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/stores/auth";

export interface PublicRouteProps {
  children: ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const status = useAuth((s) => s.status);
  const user = useAuth((s) => s.user);

  if (status === "idle" || status === "loading") return null;

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
